import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

Vue.use(VueRouter);

import Home from "../views/Home.vue";
import SkillCourt from "../views/SkillCourt.vue";
import Users from "../views/Users.vue";

import signin from "../components/Signin1.vue";
import login from "../components/Login1.vue";

const routes = [
  { path: "/home", name: "Home", component: Home },
  { path: "/skillCourt", component: SkillCourt },
  { path: "/Users", component: Users },

  { path: "/signin", component: signin },
  { path: "/login", component: login }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  Promise.all([store.dispatch("checkAuth")]).then(() => {
    // If the user is not authenticated and he is trying to access a route different from login,signup and register - we redirect him to /signup
    if (
      !store.getters.isAuthenticated &&
      to.path != "/signin" &&
      to.path != "/login" &&
      to.path != "/"
    ) {
      next({ path: "/login" });
    } // If the user is authenticated and he is trying to access one of the routes - login,signup or register - we redirect him to home page
    else if (
      store.getters.isAuthenticated &&
      (to.path == "/signin" || to.path == "/login" || to.path == "/")
    ) {
      next({ path: "/home" });
    } else {
      next();
    }
  });
});

export default router;
